import script from "./ShiftNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ShiftNotification.vue?vue&type=script&setup=true&lang=js"

import "./ShiftNotification.vue?vue&type=style&index=0&id=27cd0c7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27cd0c7b"]])

export default __exports__